<script setup lang="ts">
import { cartBus } from '@/event/cartBus'
import {
    clearMessageAlertElementHappy,
    messageAlertElementBasketHappy
} from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'

function toggleShowAlertMessageElementHappy() {
    clearMessageAlertElementHappy()
}

function deleteElementBasketHappy() {
    const productIndex = cartBus.value.findIndex(
        (p) => p.product_id === messageAlertElementBasketHappy.value.product.product_id
    )
    cartBus.value.splice(productIndex, 1)
    // console.log(productIndex)
    clearMessageAlertElementHappy()
}
</script>

<template>
    <section
        v-if="messageAlertElementBasketHappy.message.length !== 0"
        class="section-message-alert-element-basket-happy"
    >
        <section
            class="section-overlay-message-alert-element-basket-happy"
            @click="toggleShowAlertMessageElementHappy()"
        ></section>

        <section class="section-content-message-alert-element-basket-happy">
            <div class="div-content-element-basket-happy">
                <p class="text-wrap">{{ messageAlertElementBasketHappy.message }}</p>
                <p class="font-semibold">
                    {{ messageAlertElementBasketHappy.product_name }}
                </p>
            </div>
            <div class="div-section-button-element-basket-happy">
                <button class="button-alert-element-basket-happy">
                    <svg
                        @click="toggleShowAlertMessageElementHappy()"
                        class="svg-cross-alert-element-happy"
                        viewBox="0 0 30 30"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M23.75 6.25L6.25 23.75M6.25004 6.25L23.75 23.75"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
                <button class="button-alert-element-basket-happy">
                    <svg
                        @click="deleteElementBasketHappy()"
                        class="svg-submit-delete-element-happy"
                        viewBox="0 0 18 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M17 1L6 12L1 7"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </section>
    </section>
</template>

<style scoped>
.section-message-alert-element-basket-happy {
    @apply absolute inset-0 z-30 h-full w-full flex items-center justify-center;
}

.section-overlay-message-alert-element-basket-happy {
    @apply w-full h-full relative;
}

.section-content-message-alert-element-basket-happy {
    @apply absolute bg-border-red-happy-light z-30 flex flex-col items-center flex-wrap justify-center rounded-xl p-4 gap-3;
}

.div-content-element-basket-happy {
    @apply flex flex-col items-center;
}

.div-section-button-element-basket-happy {
    @apply flex justify-between w-full;
}

.button-alert-element-basket-happy {
    @apply p-2 rounded-lg min-w-10 max-w-10 min-h-10 max-h-10 flex justify-center items-center;
}

.button-alert-element-basket-happy:active {
    @apply bg-header-red-happy;
}

.button-alert-element-basket-happy:active .svg-cross-alert-element-happy,
.button-alert-element-basket-happy:active .svg-submit-delete-element-happy {
    @apply stroke-text-dark-happy-light;
}

.svg-cross-alert-element-happy {
    @apply stroke-bg-happy-light min-w-6 min-h-6 max-h-6 max-w-6;
}

.svg-submit-delete-element-happy {
    @apply stroke-bg-happy-light min-w-5 min-h-5 max-h-5 max-w-5;
}

@media (hover: hover) {
    .button-alert-element-basket-happy:hover {
        @apply bg-header-red-happy;
    }
    .button-alert-element-basket-happy:hover .svg-cross-alert-element-happy,
    .button-alert-element-basket-happy:hover .svg-submit-delete-element-happy {
        @apply stroke-text-dark-happy-light;
    }
}
</style>
